import React from 'react';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { setGuardianshipStatementModalVisibleAction } from 'redux/actions/modal.action';
import { RootReducersState } from 'redux/reducers';
import { IProps } from 'components/GuardianshipStatementModal/types';
import Modal from 'components/Modal';

const GuardianshipStatementModal: React.FC<IProps> = (props) => {
  const handleClose = () => {
    props.setGuardianshipStatementModalVisible(false);
  };

  return (
    <>
      {props.modal.guardianshipStatementModalVisible && (
        <div className="guardianship-statement-modal">
          <Modal
            visible={props.modal.guardianshipStatementModalVisible}
            title="監護宣告說明"
            confirmButton={false}
            cancelButton={false}
            onCancel={handleClose}
          >
            <div className="element__part">
              <p>配合保險法第一百零七條之一修正案，須請要保人或被保險人聲明下列事項，並請要保人/被保人或法定代理人須本人親自簽名相關聲明書，故旺旺友聯線上投保無法提供您相關網路服務，造成您的不便敬請見諒。</p>
            </div>
            <div className="element__part">
              <span>甚麼是「監護宣告」?</span>
              <p>有精神障礙或其他心智缺陷，不能與他人溝通或不瞭解他人表達的意思。比方說：長期昏迷、植物人、嚴重的智能障礙或精神疾病...等等，聲請人可聲請法院對其為監護之宣告。此時該受監護宣告之人成為無行為能力人，法院除了會同時選監護人來擔任他(她)的法定代理人外，也會再選一位適當的人跟監護人一起開具受監護宣告人的財產明細清冊。</p>
            </div>
            <div className="element__part">
              <span>誰可以提出申請?</span>
              <p>本人、配偶、四親等內之親屬(即父母、祖父母、子女、孫子女、兄弟姊妹、堂兄弟姊妹等)、最近一年有共同居住事實之其他親屬、檢察官、直轄市、縣(市)政府或社會福利機構。</p>
            </div>
            <div className="element__part">
              <span>需要檢附那些文件？</span>
              <ol>
                <li>一、家事聲請狀。</li>
                <li>二、應受監護宣告之人、聲請人、擬擔任監護人及會同開具財產清冊人的戶籍謄本各 1 份。</li>
                <li>三、應受監護宣告之人的醫生診斷證明或殘障手冊影本。</li>
                <li>四、其他法院要求提出的文件。</li>
                <li>五、聲請人可向法院推舉監護人或會同開具財產清冊人之人選，並應檢附「 親屬會議同意書」及「親屬系統表」。</li>
              </ol>
            </div>
            {
              /**
                <div className="element__part">
                  <p>
                    發布/更新日期: 2020-02-28<br />
                    警示等級: 橙色警示-避免非必要旅行<br />
                    國家地區: 日本-北海道<br />
                    國家地區英文名稱: Japan-Hokkaido<br />
                    警示說明: 鑒於日本「新型冠狀病毒肺炎」（武漢肺炎」確診病例持續增加，近8成為當地或疑似當地感染，其中未知感染源者高達29％，且已發生數起社區及醫院群聚感染。美國疾病預防管制中心（CDC）已將日本列為第二級旅遊「警示」（Alert），指出日本疫情已進入社區傳播階段，建議遊客應始終避免與確診病例接觸。美國國務院亦於本（109）年2月22日將日本提升至第二級「強化注意旅遊安全」（exercise increased caution）。我國流行疫情指揮中心也已於2月22日將日本旅遊疫情調升為二級警示。另目前包括以色列、韓國、泰國、不丹、密克羅尼西亞聯邦、東加王國、薩摩亞、索羅門群島、吉里巴斯等9國已發布對日本旅遊警示並建議該國國人避免赴日。此外，日本北海道確診病例持續增加，截至2月28日已高達66例，高居日本之冠，北海道知事已宣布進入緊急狀態，並呼籲民眾週末避免外出。考量我國與日本往來密切，日本為我國出訪旅客最多之國家，外交部為保障國人權益，自即日起調升日本旅遊警示燈號為「黃色」，提醒國人特別注意安全並檢討應否前往，另調升北海道旅遊警示燈號為「橙色」，建議避免非必要旅行。
                  </p>
                </div>
                <div className="element__part">
                  <p>國人在日期間倘遭遇急難需要協助，可請國內親友撥打「外交部緊急聯絡中心」電話：0800-085-095，或撥打我駐札幌辦事處處緊急聯絡電話+81-80-1460-2568（日本境內請直撥080-1460-2568）。</p>
                </div>
             */
            }
          </Modal>
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state: RootReducersState) => ({
  modal: state.modal
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setGuardianshipStatementModalVisible: (visible: boolean) => dispatch(setGuardianshipStatementModalVisibleAction(visible))
});

export default connect(mapStateToProps, mapDispatchToProps)(GuardianshipStatementModal);
